import React, { Component } from 'react';
import Spiner from '../../../../../helpers/Spiner/Spiner';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { connect } from 'react-redux'
import { required, email, confirmation, length } from 'redux-form-validators'
import PropTypes from 'prop-types'
import InputField from '../../../../../helpers/Fields/InputField';
import CheckboxField from '../../../../../helpers/Fields/CheckboxField';
import { createTeacher, updateTeacherData, resetPswTeacher } from '../../../../actions';
import {cloneDeep} from 'lodash';
import SelectField from '../../../../../helpers/Fields/SelectField';
import {toastr} from 'react-redux-toastr'

class FormContent extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  constructor(props) {
    super(props)
    this.state = {
      spiner: false,
    }
  }
  

  submit = async (values)=> {
    const {formatMessage} = this.context;
    const {handleClose2, initialValues, dispatch, typeForm} = this.props;
    this.setState({spiner: true});
    let result = {};
    if(typeForm == 'reset-password'){
      result = await resetPswTeacher(cloneDeep(values));
    } else if(initialValues.id){
      result = await updateTeacherData(cloneDeep(values));
    } else {
      result = await createTeacher(cloneDeep(values));
    }
   
    this.setState({spiner: false});
    if(result.status){
      handleClose2();
      if(typeForm == 'reset-password'){
        toastr.success(formatMessage('txtResetPswTitle'), formatMessage('txtResetPswMessage'))
      } else if(initialValues.id) {
        dispatch({type: 'UPDATE_TEACHER', data: result.data})
      } else {
        dispatch({type: 'CREATE_TEACHER', data: result.data})
      }
    } else {
      throw new SubmissionError(result.error)
    } 
  }
  render() {
    const {formatMessage} = this.context;
    const { spiner } = this.state;
    const { handleSubmit, handleClose, initialValues, typeForm } = this.props;

    if(typeForm == 'reset-password'){
      return (
        <form className="create-dialog-form" style={{position: 'relative'}} onSubmit={handleSubmit(this.submit)}>
          {spiner && <div style={{position: 'absolute', display: 'flex', background: 'rgba(255, 255, 255, 0.4)', alignItems: 'center', width: '100%', height: '100%'}}>
            <Spiner />
          </div>}
          <Field 
            name='password'
            label={formatMessage('txtCaptionTeacherPassword')}
            component={InputField}
            type="password"
            autocomplete="new-password"
            validate={[required(), length({ min: 7 })]}
          />
          <Field 
            name='password-confirm'
            label={formatMessage('txtCaptionTeacherPasswordConfirm')}
            component={InputField}
            type="password"
            autocomplete="new-password"
            validate={[required(), confirmation({ field: 'password', fieldLabel: formatMessage('txtCaptionTeacherPassword') })]}
          />
          <div className="create-dialog-form__group flex" style={{justifyContent: 'space-between',
            flexDirection: 'row'}}>
          <button className="btn btn-warning" type="button" onClick={() => {
            handleClose();
          }}>{formatMessage('btnModalCancel')}</button>
           <button className="btn btn-primary" type="submit">{formatMessage(!initialValues.id ? 'btnModalCreateTeacher': 'btnModalUpdateTeacher')}</button>
        </div>
        </form>
      )
    }

    return (
      <form className="create-dialog-form" style={{position: 'relative'}} onSubmit={handleSubmit(this.submit)}>
        {spiner && <div style={{position: 'absolute', display: 'flex', background: 'rgba(255, 255, 255, 0.4)', alignItems: 'center', width: '100%', height: '100%'}}>
          <Spiner />
        </div>}
        <Field 
          name='username'
          label={formatMessage('txtCaptionTeacherUserName')}
          component={InputField}
          validate={[required()]}
          disabled={initialValues.id}
          autocomplete="off"
        />
        <Field 
          name='firstname'
          label={formatMessage('txtCaptionTeacherFirstName')}
          component={InputField}
          validate={[required()]}
        />
        <Field 
          name='lastname'
          label={formatMessage('txtCaptionTeacherLastName')}
          component={InputField}
          validate={[required()]}
        />
        <Field 
          name='email'
          label={formatMessage('txtCaptionTeacherEmail')}
          component={InputField}
          validate={[required(), email()]}
          autocomplete="off"
        />
        <Field 
          name='gender'
          label={formatMessage('txtCaptionTeacherGender')}
          component={SelectField}
          options={[
            {title: 'Male', value: 1},
            {title: 'Female', value: 2},
          ]}
          validate={[required()]}
        />
        {!initialValues.id && <Field
          name='password'
          label={formatMessage('txtCaptionTeacherPassword')}
          component={InputField}
          validate={[required(), length({ min: 7 })]}
          type="password"
          autocomplete="new-password"
        />}
        <div className="permission">
          <label>{formatMessage('txtCaptionTeacherPermission')}</label>
          <Field
            name='permission.allow_delete_question'
            label={formatMessage('txtCaptionTeacherAllowDeleteQuestion')}
            component={CheckboxField}
            type="int"
          />
          <Field
            name='permission.allow_empty_trash'
            label={formatMessage('txtCaptionTeacherAllowEmptyTrash')}
            component={CheckboxField}
            type="int"
          />
          <Field
            name='permission.add_new_question'
            label={formatMessage('txtCaptionTeacherAddNewQuestion')}
            component={CheckboxField}
            type="int"
          />
          <Field
            name='permission.classrooms'
            label={formatMessage('txtCaptionTeacherClassRooms')}
            component={CheckboxField}
            type="int"
          />
          <Field
            name='permission.quizzes'
            label={formatMessage('txtCaptionTeacherQuizzes')}
            component={CheckboxField}
            type="int"
          />
          <Field
            name='permission.statistics'
            label={formatMessage('txtCaptionTeacherStatistics')}
            component={CheckboxField}
            type="int"
          />
          <Field
            name='permission.lecture_hall'
            label={formatMessage('txtCaptionTeacherLectureHall')}
            component={CheckboxField}
            type="int"
          />
          <Field
            name='permission.flash_card'
            label={formatMessage('txtCaptionTeacherFlashcard')}
            component={CheckboxField}
            type="int"
          />
        </div>
        <div className="create-dialog-form__group flex" style={{justifyContent: 'space-between',
            flexDirection: 'row'}}>
          <button className="btn btn-warning" type="button" onClick={() => {
            handleClose();
          }}>{formatMessage('btnModalCancel')}</button>
           <button className="btn btn-primary" type="submit">{formatMessage(!initialValues.id ? 'btnModalCreateTeacher': 'btnModalUpdateTeacher')}</button>
        </div>
      </form>
    );
  }
}


FormContent = reduxForm({
  form: 'form_teacher',
  enableReinitialize: true,
})(FormContent);



const mapStateToProps = (state, ownProps) => ({
  
})

const mapDispatchToProps = {
}

export default connect(mapStateToProps)(FormContent);




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/UserOrganisation/components/ModalForm/components/FormContent/FormContent.jsx